import React from "react";
import { PROCESS } from "../mock";
import { Script } from "./Script";

export default function Process() {
  return (
    <section id="proces" className="bg-white py-24 md:py-32" data-testid="process-section">
      <div className="container-x">
        <div className="reveal max-w-2xl">
          <p className="eyebrow text-[#8b8b84]">Jak to probíhá</p>
          <h2 className="display text-[#0e0e0d] text-4xl sm:text-5xl lg:text-6xl mt-4">
            Čtyři kroky a{" "}
            <Script color="#0e0e0d" className="text-5xl sm:text-6xl lg:text-7xl mx-2">
              hotovo.
            </Script>
          </h2>
        </div>

        <div className="mt-20 grid md:grid-cols-4 gap-px bg-black/[0.08] rounded-3xl overflow-hidden">
          {PROCESS.map((s) => (
            <div key={s.num} className="reveal bg-white p-8 md:p-9" data-testid={`process-step-${s.num}`}>
              <p className="serif text-4xl text-[#0e0e0d]" style={{ fontWeight: 400 }}>
                {s.num}
              </p>
              <span className="block mt-6 mb-5 h-[2px] w-10 bg-[#d8ff00]" />
              <h3 className="display text-xl text-[#0e0e0d]">{s.title}</h3>
              <p className="text-sm text-[#5f5f59] mt-3 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
